// extracted by mini-css-extract-plugin
export default {"hatText":"AlTBrM"};